export const clientDucStatusOptions = [
  { id: 1, label: "Accept" },
  { id: 2, label: "Condition Accept" },
  { id: 3, label: "Not OK" },
  { id: 4, label: "Missing" },
  { id: 5, label: "Repair" },
  { id: 6, label: "Rework" },
  { id: 7, label: "Not In Use" },
  { id: 8, label: "Damaged/Broken" },
  { id: 9, label: "Other" },
];
